import React from 'react';
import { motion } from 'framer-motion';

// Using a placeholder image to resolve the build error.
const jahxImage = 'https://placehold.co/256x256/111827/c4b5fd?text=Jahx';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 relative">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-6xl font-orbitron font-bold mb-6">
              Why I <span className="clarity-gradient">Built This</span>
            </h2>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-gray-800/40 to-gray-900/40 p-12 rounded-3xl border border-gray-700/30 backdrop-blur-sm"
          >
            <div className="flex flex-col lg:flex-row items-center space-y-8 lg:space-y-0 lg:space-x-12">
              <div className="lg:w-1/3 flex justify-center">
                <motion.img
                  src={jahxImage}
                  alt="Jahx Character"
                  whileHover={{ scale: 1.05 }}
                  className="w-64 object-contain rounded-full"
                />
              </div>
              <div className="lg:w-2/3 text-center lg:text-left">
                <blockquote className="text-xl md:text-2xl font-poppins font-light text-gray-300 leading-relaxed mb-8 italic">
                  "After 20 years building businesses, systems, and tools that made other people millions, I realized most creators still feel like they're drowning in complexity. I built this for the people who never felt like they belonged in 'normal' business spaces—and are ready to thrive on their own terms."
                </blockquote>
                <div className="space-y-4 text-gray-400 font-poppins">
                  <p>
                    <strong className="text-white">20+ years</strong> of building systems that scale
                  </p>
                  <p>
                    <strong className="text-white">$50M+</strong> generated for clients and partners
                  </p>
                  <p>
                    <strong className="text-white">10,000+</strong> entrepreneurs helped find clarity
                  </p>
                </div>
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.5, duration: 0.8 }}
                  viewport={{ once: true }}
                  className="mt-8"
                >
                  <p className="text-gray-300 font-poppins">
                    This isn't about another course or coaching program. This is about building something that actually works—for people like us who think differently, create differently, and refuse to fit into someone else's box.
                  </p>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;